/* tslint:disable */

/**
 */
export class UserCreate {
    email?: string;
    id?: number;
    company_id?: number;
    rfid?: string;
    username?: string;
    password?: string;
    confirm_password?: string;
    role_id?: number;
    fullname?: string;
    birthday?: string;
    address?: string;
    sidn?: string;
    gender?: number;
    phone?: string;
}
